import { resolveIndividual } from "./individual";
import { getAssociatedTokenAddress } from "@solana/spl-token";
import { get } from "./utils";
export function ataResolver({ instruction, account, mint, owner, }) {
    return resolveIndividual(async ({ path, accounts, idlIx, provider }) => {
        if ((typeof instruction === "undefined" || idlIx.name === instruction) && path.join(".") === account) {
            const mintKey = get(accounts, mint.split("."));
            // @ts-ignore
            const ownerKey = owner ? get(accounts, owner.split(".")) : provider.wallet?.publicKey;
            if (mintKey && ownerKey) {
                return getAssociatedTokenAddress(mintKey, ownerKey, true);
            }
        }
        return undefined;
    });
}
//# sourceMappingURL=ataResolver.js.map